"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const icon_1 = __importDefault(require("../icon"));
const { SearchIcon } = icon_1.default;
const StyledWrapInput = styled_components_1.default.div `
  display: flex;
  align-items: center;
  padding: 0 20px;
  width: 238px;
  height: 36px;
  background: #f5f5f5;
  border: 1px solid #f5f5f5;
  border-radius: 4px;
`;
const StyledInput = styled_components_1.default.input `
  font-family: "Gotham A", "Gotham B";
  width: 100%;
  height: 100%;
  background: transparent;
  border: 1px solid transparent;
  outline: none; // check all device
  padding-left: 10px;
`;
const RotaSearchInput = ({ placeholder = "Search...", onChange, styles }) => {
    const handleChange = (value) => {
        onChange(value);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledWrapInput, { style: styles },
            react_1.default.createElement(SearchIcon, null),
            react_1.default.createElement(StyledInput, { placeholder: placeholder, onChange: (e) => handleChange(e.target.value) }))));
};
exports.default = RotaSearchInput;
